import Seo from "../components/Seo";
import { useI18n } from "../i18n/LanguageProvider";
import { useRegisterAlternates } from "../components/layout/Layout";
import { pagePath } from "../config/pages";
import { TREATMENTS } from "../data/treatments";
import { PageHero, CTABand } from "../components/Sections";
import { RevealStagger, RevealItem } from "../components/motion/Reveal";
import { TreatmentCard } from "../components/Cards";
import { webPageSchema, breadcrumbSchema } from "../lib/schema";

const META = {
  title: {
    en: "Dental Treatment in Vietnam | Treatments Guide for International Patients",
    fr: "Soins dentaires au Vietnam | Guide des traitements pour patients internationaux",
    de: "Zahnbehandlung in Vietnam | Behandlungsübersicht für internationale Patienten",
  },
  desc: {
    en: "Explore dental treatments available in Vietnam for international patients — implants, veneers, crowns and more, with clear independent information.",
    fr: "Découvrez les soins dentaires disponibles au Vietnam pour les patients internationaux — implants, facettes, couronnes et plus, avec des informations claires et indépendantes.",
    de: "Entdecken Sie Zahnbehandlungen in Vietnam für internationale Patienten — Implantate, Veneers, Kronen und mehr, mit klaren, unabhängigen Informationen.",
  },
  h1: {
    en: "Dental Treatment in Vietnam",
    fr: "Soins dentaires au Vietnam",
    de: "Zahnbehandlung in Vietnam",
  },
};

export default function TreatmentsIndex() {
  const { t, lang, p } = useI18n();
  const alternates = { en: pagePath("dentalTreatment", "en"), fr: pagePath("dentalTreatment", "fr"), de: pagePath("dentalTreatment", "de") };
  useRegisterAlternates(alternates);
  const path = pagePath("dentalTreatment", lang);
  const title = META.h1[lang] || META.h1.en;

  return (
    <>
      <Seo
        title={META.title[lang] || META.title.en}
        description={META.desc[lang] || META.desc.en}
        path={path}
        alternates={alternates}
        lang={lang}
        jsonLd={[
          webPageSchema({ name: title, description: META.desc[lang] || META.desc.en, path }),
          breadcrumbSchema([{ name: t.common.home, path: p("home") }, { name: title, path }]),
        ]}
      />
      <PageHero
        eyebrow={t.treatmentsSection.eyebrow}
        title={title}
        intro={t.treatmentsSection.sub}
        crumbs={[{ name: title, to: path }]}
      />
      <section className="container-dv py-16 lg:py-20">
        <RevealStagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TREATMENTS.map((tr) => (
            <RevealItem key={tr.key}>
              <TreatmentCard treatment={tr} />
            </RevealItem>
          ))}
        </RevealStagger>
      </section>
      <CTABand />
    </>
  );
}
